import { FieldProps } from 'formik';
import { ReactElement, useMemo } from 'react';
import DeclarationField from 'views/declarations/common/DeclarationField';
import { getFormikProps } from 'views/declarations/utils/form-utils';
import { useTranslation } from 'react-i18next';
import CountrySelect from '../../../../../components/ui/composed/declarations/CountrySelect';
import { ValidationSchema, validators } from '../validations/validations';
import HideComponent from '../../../../../utils/HideComponent';

type Fields = 'registrationNationalityCode';

export const nationalityOfActiveMeansOfTransportCrossingTheBorderBlockValidation: {
    childValidators: {
        borderTransportMeans: ValidationSchema<Fields>;
    };
} = {
    childValidators: {
        borderTransportMeans: {
            childValidators: {
                registrationNationalityCode: [validators.exact(2)],
            },
        },
    },
};

interface Props extends BlockProps<Fields> {}

const NationalityOfActiveMeansOfTransportCrossingTheBorderBlock = ({
    path = 'borderTransportMeans',
    hide,
}: Props): ReactElement => {
    const { t } = useTranslation('form');

    const ucc = useMemo(() => '7/15', []);
    return (
        <HideComponent hide={hide}>
            <DeclarationField pathPrefix={path} name="registrationNationalityCode">
                {({ form, field }: FieldProps<any>) => (
                    <CountrySelect
                        refNumber={ucc}
                        label={t('nationalityOfMeansOfTransportAtTheBorder')}
                        {...getFormikProps(field.name, form)}
                        condensed
                    />
                )}
            </DeclarationField>
        </HideComponent>
    );
};

export default NationalityOfActiveMeansOfTransportCrossingTheBorderBlock;
